import type { PermissionScope } from '../../api/interfaces/permissions';
import type { UserPermissionGrant } from '../stores/auth.store';

const permissionScopePriority: Record<PermissionScope, number> = {
  OWN: 0,
  BRANCH: 1,
  SYSTEM: 2,
};

export const hasPermission = (
  permissions: readonly UserPermissionGrant[],
  permissionName: string,
  scope?: PermissionScope,
): boolean =>
  permissions.some((permission) => {
    if (permission.name !== permissionName) {
      return false;
    }

    if (scope === undefined) {
      return permission.scopes.length > 0;
    }

    const requiredRank = permissionScopePriority[scope];
    return permission.scopes.some((permissionScope) => permissionScopePriority[permissionScope] >= requiredRank);
  });

export const isAdminUser = (permissions: readonly UserPermissionGrant[]): boolean =>
  hasPermission(permissions, 'roles.manage', 'SYSTEM');
